

import { BasicProperties } from "../BasicProperties";
import { Localize } from "@goodgamestudios/localization";

export class BasicStandardOkDialogProperties extends BasicProperties {
    public buttonLabel_ok: string = "Okay";
    public title: string = "";
    public copy: string = "";
    public functionOk: Function;
    public functionCancel: Function;

    constructor(title: string, copy: string, functionOk: Function = null, buttonLabel_ok: string = "", functionCancel: Function = null) {
        super();
        this.functionOk = functionOk;
        this.functionCancel = functionCancel;

        if (buttonLabel_ok.length > 0) {
            this.buttonLabel_ok = buttonLabel_ok;
        }
        else {
            this.buttonLabel_ok = this.delegateText("generic_btn_okay");
        }
        this.title = title;
        this.copy = copy;
        // super();
    }

    protected delegateText(textId: string): string {
        return Localize.text(textId);
    }
}

